import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import type { JSX } from 'react';
import './console.css';
import './console-aree.css';
import { ConsoleLayout } from './ConsoleLayout.tsx';
import { ConsoleNav } from './ConsoleNav.tsx';
import { StatoPiattaforma } from './StatoPiattaforma.tsx';
import { GrafoCorpus } from './GrafoCorpus.tsx';
import { RisoluzioneAssistita } from './RisoluzioneAssistita.tsx';
import { VistaArea } from './VistaArea.tsx';
import { AREE } from './data/aree.ts';
import { VISTE_PROPRIE } from './data/navigazione.ts';

/**
 * `/admin/piattaforma` (era `/console` nel documento originale — questo
 * cruscotto si è spostato con la fusione A.5, "Riordino della mappa delle
 * rotte" §4, prima di questo documento) — una rotta, molte viste.
 *
 * PERCHÉ NON UNA ROTTA PER AREA: l'operatore passa continuamente da un'area
 * all'altra e tutte condividono testata, navigazione e avviso AI Act. Ma la
 * vista sta nella QUERY (?vista=grafo), non solo nello stato: un collega deve
 * poter incollare in chat il link dell'area che sta guardando, e il tasto
 * indietro del browser deve funzionare.
 *
 * ID di rotta per `useSearch`/`navigate` (non l'URL, invariato — vedi la
 * stessa nota in `admin/skills/$skillId.tsx`): sotto il segmento pathless
 * `(amministrazione)` la catena di id include `/_amministrazione`.
 */
export function ConsolePage(): JSX.Element {
  const navigate = useNavigate();
  const { vista } = useSearch({ from: '/_amministrazione/admin/piattaforma' });
  const attiva = vista && (AREE[vista] || (VISTE_PROPRIE as readonly string[]).includes(vista)) ? vista : 'stato';

  const vaiA = useCallback((v: string) => {
    void navigate({ to: '/admin/piattaforma', search: { vista: v } });
    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <ConsoleLayout nav={<ConsoleNav vista={attiva} onVista={vaiA} />} onVista={vaiA}>
      {attiva === 'stato' && <StatoPiattaforma onVista={vaiA} />}
      {attiva === 'grafo' && <GrafoCorpus />}
      {attiva === 'aiuto' && <RisoluzioneAssistita />}
      {AREE[attiva] && <VistaArea id={attiva} onAiuto={() => { vaiA('aiuto'); }} />}
    </ConsoleLayout>
  );
}
